<template>
  <BaseModalSmall @close="$emit('close')">
    <div
      ref="modalElement"
      tabindex="-1"
    >
      <Flex direction="column">
        <BaseText>
          {{ $t('customers.async_export_disclaimer', {
            email: user && sentToUser ? user.email : company.notificationEmail
          }) }}
        </BaseText>
        <BaseRadio
          v-if="user && user.email !== company.notificationEmail"
          v-model="sentToUser"
          :options="[
          {
            label: $t('export_page.user_email', { email: user?.email }),
            value: true
          },
          {
            label: $t('export_page.company_email', {
              email: company.notificationEmail
            }),
            value: false
          }
        ]"
          v-test="'export-modal-radio'"
        />
      </Flex>
    </div>
    <template #footer>
      <BaseButton
        @click="onSubmit"
        v-test="'export-modal-submit'"
      >
        {{ $t('global.actions.export') }}
      </BaseButton>
    </template>
  </BaseModalSmall>
</template>

<script
  lang="ts"
  setup
>
import { useCompanyStore } from '@/stores/company';
import { useUserStore } from '@/stores/user';

const { company } = useCompanyStore();
const { user } = useUserStore();

const emit = defineEmits(['close', 'submit']);

const sentToUser = ref(true);

const onSubmit = () => {
  emit('submit', sentToUser.value ? user?.email : undefined);
  emit('close');
};

const modalElement = ref<HTMLElement | null>(null);

onMounted(() => {
  // Focus on the modal element to ensure that focus is removed from any underlying forms, to prevent multiple submits when pressing enter
  modalElement.value?.focus();
});
</script>
